import { render } from "./CommsTable.vue?vue&type=template&id=1b8e0f38&scoped=true&lang=pug"
import script from "./CommsTable.vue?vue&type=script&lang=js"
export * from "./CommsTable.vue?vue&type=script&lang=js"

import "./CommsTable.vue?vue&type=style&index=0&id=1b8e0f38&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8e0f38"]])

export default __exports__